<template>

    <div class="pdl">
        <div class="btn" @click="openModal()">添加权限人员</div>
        <el-table border header-cell-class-name="tableHeader" :data="tableData">
            <el-table-column label="人员编码" prop="userCode"></el-table-column>
            <el-table-column label="人员账号" prop="userName"></el-table-column>
            <el-table-column label="人员名称" prop="fullName"></el-table-column>
            <el-table-column label="职位编码" prop="positionCode"></el-table-column>
            <el-table-column label="职位名称" prop="positionName"></el-table-column>
            <el-table-column label="所属组织编码" prop="orgCode"></el-table-column>
            <el-table-column label="所属组织名称" prop="orgName"></el-table-column>
        </el-table>
        <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
    </div>
</template>
<script>
import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';

export default {
  props: {
    value: [Array, Object],
    disabled: Boolean,
    fApi: Object,
    getRule: Function,
    setValue: Function,
  },
  components: {
    SelectConfig,
  },
  data() {
    return {
      tableData: [],
    };
  },
  watch: {
    value: {
      deep: true,
      handler(value) {
        console.log('// 标记为已执行');
        console.log(value);
        if (value) {
          console.log(value);
          this.tableData = value;
        }
      },
    },
  },
  mounted() {

  },
  methods: {
    openModal() {
      const params = {
        functionCode: 'deliver_config_user',
        noReset: true,
        paramData: {
          enableStatus: '009',
          delFlag: '009',
        },
        pageAble: false,
        data: this.tableData || [],
        selectionList: [],
        idKey: 'id',
      };
      this.$refs.selectConfig.openSelectModal(params);
    },
    onGetSelect(val) {
      console.log('onGetSelect ~ val:', val);
      this.tableData = val;

      this.changeEvent();
    },
    changeEvent() {
      this.$emit('change', this.tableData);
      this.$emit('input', this.tableData);
    },
  },
};
</script>
  <style lang="less" scoped>
  .pdl {
    //padding-left: 125px;
  }

  /deep/ .tableHeader {
    background-color: #e8e8e8 !important;
  }

  /deep/ .el-tag {
    margin: 4px;
  }

  .mb10 {
    margin-bottom: 10px;
  }
  .btn{
    width: 90px;
    height: 30px;
    line-height: 30px;
    background-color: #c34231;
    border-radius: 6px;
    text-align: center;
    font-size: 12px;
    color: white;
    margin-top: 40px;
    margin-bottom: 10px;
  }

  .cusEtag {
    white-space: break-spaces;
    word-break: break-all;
    height: auto;
    position: relative;
    padding-right: 14px;

    /deep/ .el-icon-close {
      position: absolute;
      right: 1px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .tD {
    width: 100%;
    margin-top:20px;

    .tD_area {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      .tD_right {
        margin-left: 20px;
        font-size: 14px;
        color: #606266;
        display: flex;
        align-items: center;
      }

      .tD_left {
        font-size: 14px;
        color: #606266;
        width:275px;
        span{
          color:#de4e52;
           font-size: 14px;
        }
      }

    }
  }

</style>
